import React from 'react'
import { Card } from 'semantic-ui-react'

export const General = () => (
    <Card fluid className='guide-container'>
        <Card.Content>
        <Card.Description>

        <h3>Story Mode</h3>
        <p>Get 3 tars on all of the Story quests. By 3 starring the quests, you will receive more rewards which will help you gather more resources to rank up your Guardains and Talents.</p>
        <p>If you aren't strong enough to finish a quest, you can always go back and farm experience on an earlier quest. Sometimes you may even find a Scholar Crystal which conains books to rank up Talents.</p>

        <h3>Upgrades</h3>
        <p>Prioritize your upgrades and only spend resources on Guardians and Talents you plan on using.</p>
        <p>In the beginning it may seem as if you have the extra gold to rank up all your Talents but it will start to get expensive really quickly.</p>
        
        <h3>Resource Farming</h3>
        <p>Farm gold and gem dailies so you can upgrade your Guardians and Talents. The higher the rank, the more gold and gems you will need to have in stock.</p>
        <p>Keeping a superflous amount on hand will ensure you will be able to rank up your prioritized almost immediately.</p>

        </Card.Description>
        </Card.Content>
    </Card>
)
